<template>
  <dx-modal
    :value="show"
    size="md"
    id="modal-notification-screen"
    class="notification-screen"
    @input="$emit('close')"
  >
    <div class="notification-screen-hero">
      <span class="notification-screen-badge">Novidade</span>
      <span class="notification-screen-icon"><fa-icon :icon="['fal', 'sparkles']" /></span>
      <div class="notification-screen-title">{{ notification.title }}</div>
      <div class="notification-screen-message">{{ notification.message }}</div>
    </div>
    <ol class="notification-screen-sections">
      <li
        v-for="(section, i) in notification.sections"
        :key="i"
        class="notification-screen-section"
      >
        <span class="notification-screen-number">{{ i + 1 }}</span>
        <div>
          <div class="notification-screen-section-title">{{ section.title }}</div>
          <div class="notification-screen-section-text">{{ section.text }}</div>
        </div>
      </li>
    </ol>
    <template slot="footer">
      <button class="btn btn-primary btn-block" @click="$emit('close')">Entendi</button>
    </template>
  </dx-modal>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    notification: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/_variables.scss';

.notification-screen {
  .modal-header {
    padding-bottom: 0;
  }
  .notification-screen-hero {
    align-items: center;
    background: linear-gradient(
      160deg,
      lighten($primary-color, 43%),
      lighten($primary-color, 38%)
    );
    border: lighten($primary-color, 30%) solid $border-width;
    border-radius: $border-radius;
    display: flex;
    flex-direction: column;
    gap: .3rem;
    margin-top: $layout-spacing;
    padding: $layout-spacing-lg $layout-spacing-lg $layout-spacing-lg;
    position: relative;
    text-align: center;
  }
  .notification-screen-badge {
    background-color: $primary-color;
    border-radius: 1rem;
    color: $light-color;
    font-size: .5rem;
    font-weight: 700;
    letter-spacing: .06em;
    line-height: 1;
    padding: .2rem .45rem;
    position: absolute;
    right: .5rem;
    text-transform: uppercase;
    top: -.45rem;
  }
  .notification-screen-icon {
    align-items: center;
    background-color: $light-color;
    border-radius: 50%;
    box-shadow: 0 2px 6px rgba($primary-color, .2);
    color: $primary-color;
    display: flex;
    font-size: 1.4rem;
    height: 3rem;
    justify-content: center;
    margin-bottom: .3rem;
    width: 3rem;
  }
  .notification-screen-title {
    color: $dark-color;
    font-size: $font-size-lg;
    font-weight: 700;
    line-height: 1.2;
  }
  .notification-screen-message {
    color: $gray-color-dark;
    font-size: $font-size-sm;
    line-height: 1.4;
    white-space: pre-line;
  }
  .notification-screen-sections {
    list-style: none;
    margin: $layout-spacing-lg 0 0;
    padding: 0;
  }
  .notification-screen-section {
    display: flex;
    gap: $layout-spacing-lg;
    margin: 0;
    padding: $layout-spacing-lg $layout-spacing-sm;
    & + .notification-screen-section {
      border-top: $border-width solid $border-color;
    }
  }
  .notification-screen-number {
    align-items: center;
    background-color: lighten($primary-color, 34%);
    border-radius: 50%;
    color: $primary-color;
    display: flex;
    flex: 0 0 auto;
    font-size: $font-size-sm;
    font-weight: 700;
    height: 1.2rem;
    justify-content: center;
    width: 1.2rem;
  }
  .notification-screen-section-title {
    color: $dark-color;
    font-weight: 700;
    line-height: 1.2rem;
  }
  .notification-screen-section-text {
    color: $gray-color-dark;
    font-size: $font-size-sm;
    line-height: 1.45;
    margin-top: $layout-spacing-sm;
    white-space: pre-line;
  }
}
</style>
